// extracted by css-extract-rspack-plugin
export default {"blocksLayout":"blocksLayout-wRtERd","blocksLayoutTop":"blocksLayoutTop-EhHje3","blocksLayoutColumns":"blocksLayoutColumns-M9deSx","blockLayoutColumn":"blockLayoutColumn-OOsnWE"};